import React, {
  useRef,
  useEffect,
  useCallback,
  useState,
  useMemo,
} from 'react';
import { toast } from 'react-toastify';

import {
  TextField as Input,
  FormHelperText,
  IconButton,
  CircularProgress,
  FormControl,
} from '@material-ui/core';
import { Search, Clear, Save } from '@material-ui/icons';
import { useField } from '@unform/core';
import {
  assign,
  concat,
  isEmpty,
  find,
  trim,
  isEqual,
  isArray,
  isUndefined,
} from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';

import { Modal } from '~/components';
import { Hidden } from '~/components/Form';
import { t } from '~/helpers';
import api from '~/services/api';

import { SearchTable } from './component';
import * as S from './styles';

export default function PesquisaTabelaInput({
  name,
  url,
  onRow,
  primary,
  secondary,
  getValue,
  query,
  header,
  nowrap,
  maxWidth,
  maxHeight,
  disabled,

  disabledDigitacao,

  amaggi,
  filterByUser,
  aguarda,
  userSelectFilterCountMaisQueUm,
  onCallbackNaoEncotrado,
  onCallbackConfirmado,
  onCallbackClose,
  onCallbackCampoLimpo,
  desabilitaPesquisaInput,
  desabilitaClearInputAtive,
  onCallbackDesabilitaClearInputAtive,
  mostraButtonLimpar,
  ...rest
}) {
  const [loading, setLoading] = useState(false);
  const [disableComValue, setDisableComValue] = useState(false);
  const [description, setDescription] = useState('');
  const [otherError, setOtherError] = useState('');

  const inputRef = useRef(null);
  const inputSecondRef = useRef(null);
  const modalRef = useRef(null);

  const cells = useMemo(() => header, [header]);

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError,
  } = useField(name);

  const handleLimparValue = useCallback(() => {
    if (inputRef) {
      inputRef.current.value = '';
    }
    setDescription('');
    getValue('');
    onCallbackCampoLimpo();
  }, []);

  const handlePrimaryFocus = useCallback(() => {
    clearError();
    setOtherError('');
  }, []);

  const handleGetFindItem = useCallback(
    async (params, valor) => {
      try {
        setLoading(true);

        let dataQuery = params;

        if (!isEmpty(query.wherefield)) {
          if (isEmpty(dataQuery)) dataQuery = query;
          else if (isEmpty(dataQuery.wherefield))
            dataQuery = assign(dataQuery, query);
          else {
            dataQuery = {
              ...dataQuery,
              wherefield: concat(dataQuery.wherefield, query.wherefield),
              valuewherefield: concat(
                dataQuery.valuewherefield,
                query.valuewherefield
              ),
              typewherefield: concat(
                dataQuery.typewherefield,
                query.typewherefield
              ),
            };
          }
        }

        const { data } = await api.get(url, {
          params: {
            ...dataQuery,
            pesquisalista: true,
            filteruser: filterByUser,
          },
          paramsSerializer: (param) => qs.stringify(param),
        });

        if (amaggi && data.items.length > 1) {
          setDescription('');
          getValue('');
          return;
        }

        if (userSelectFilterCountMaisQueUm && data.items.length > 1) {
          setOtherError(t('s.geral.encotroumaisdeumregistro'));
          setDescription('');
          getValue('');
          return;
        }

        // console.log(valor);

        if (data?.totalCount === 0) {
          setOtherError(t('s.geral.nadaencontrado'));
          setDescription('');
          getValue(valor);
          inputRef.current.value = valor;
          onCallbackNaoEncotrado(valor);
          return;
        }

        onCallbackConfirmado(data.items[0]);
        setDescription('achou');
        getValue(data.items[0]);
      } catch (err) {
        setDescription('');
        setOtherError(t('s.geral.nadaencontrado'));

        onCallbackNaoEncotrado(valor);

        // if (isArray(err)) err.map((e) => toast.error(t(e)));
        // else toast.error(t(err));
      } finally {
        setLoading(false);
      }
    },
    [url, secondary, query]
  );

  const handleChangeValueField = useCallback(
    (value) => {
      inputRef.current.value = value[primary];
      setDescription('achou');
      getValue(value);
      onCallbackConfirmado(value);
    },
    [primary, secondary]
  );

  const handleKeyPress = useCallback(
    (key, value) => {
      setDescription('');
      clearError();
      setOtherError('');
      if (key === 'Enter' && !!value)
        handleGetFindItem(
          {
            wherefield: [primary],
            valuewherefield: [value],
            typewherefield: ['EQUALS'],
          },
          value
        );
    },
    [primary, query]
  );

  const handleOnBlur = useCallback(
    (value) => {
      // setDescription('');
      // if (value) {
      //   handleGetFindItem({
      //     wherefield: [primary],
      //     valuewherefield: [value],
      //     typewherefield: ['EQUALS'],
      //   });
      // }
    },
    [primary]
  );

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      setValue: (ref, value) => {
        ref.value = value;
        handleOnBlur(value);
      },
      clearValue: (ref) => {
        ref.value = '';
        setDescription('');
      },
    });
  }, [registerField, fieldName]);

  useEffect(() => {
    if (!aguarda) {
      if (!isUndefined(defaultValue))
        handleGetFindItem({
          wherefield: [primary],
          valuewherefield: [defaultValue],
          typewherefield: ['EQUALS'],
        });
    }
  }, [defaultValue, primary]);

  useEffect(() => {
    if (desabilitaClearInputAtive) {
      inputRef.current.value = '';
      setDescription('');
      getValue('');
      onCallbackDesabilitaClearInputAtive();
    }
  }, [desabilitaClearInputAtive]);

  return (
    <>
      <S.Wrapper error={!!error || !!otherError}>
        <S.GroupInput error={!!error || !!otherError}>
          <Input
            inputRef={inputRef}
            defaultValue={defaultValue}
            onFocus={handlePrimaryFocus}
            disabled={
              disabledDigitacao ||
              desabilitaPesquisaInput ||
              description ||
              loading ||
              disabled
            }
            // disabled={desabilitaPesquisaInput || description || loading || disabled}
            variant="outlined"
            size="small"
            className="input"
            InputLabelProps={{ shrink: true }}
            onKeyPress={({ key, target }) => handleKeyPress(key, target.value)}
            onBlur={({ target }) => handleOnBlur(target.value)}
            {...rest}
            InputProps={{
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                </>
              ),
            }}
          />

          {!description && !desabilitaPesquisaInput && (
            <IconButton
              size="small"
              type="button"
              onClick={() => modalRef.current.handleOpenModal()}
              disabled={loading || disabled}
            >
              <Search />
            </IconButton>
          )}

          {(description || desabilitaPesquisaInput) && (
            <IconButton
              size="small"
              type="button"
              onClick={() => handleLimparValue()}
              disabled={loading || disabled}
            >
              <Clear />
            </IconButton>
          )}
        </S.GroupInput>
        <FormHelperText>{error || otherError}</FormHelperText>
      </S.Wrapper>

      <Modal
        form
        onClose={onCallbackClose}
        noPadding
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth={maxWidth}
        ref={modalRef}
        title={rest.label}
        fullScreen={window.innerWidth <= 425}
        component={(rest) => (
          <SearchTable
            keys={[primary]}
            nowrap={nowrap}
            url={url}
            onRow={onRow}
            header={cells}
            query={query}
            maxHeight={maxHeight}
            changeField={handleChangeValueField}
            {...rest}
          />
        )}
      />
    </>
  );
}

PesquisaTabelaInput.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.string.isRequired,
  getValue: PropTypes.func,
  query: PropTypes.shape({
    wherefield: PropTypes.arrayOf(PropTypes.string).isRequired,
    valuewherefield: PropTypes.arrayOf(PropTypes.string).isRequired,
    typewherefield: PropTypes.arrayOf(PropTypes.string).isRequired,
    pesquisalista: PropTypes.arrayOf(PropTypes.string), // Se essa chave for opcional
  }),
  // query: PropTypes.objectOf(
  //   PropTypes.shape({
  //     wherefield: PropTypes.arrayOf(PropTypes.string).isRequired,
  //     valuewherefield: PropTypes.arrayOf(PropTypes.string).isRequired,
  //     typewherefield: PropTypes.arrayOf(PropTypes.string).isRequired,
  //   })
  // ),
  nowrap: PropTypes.bool,
  header: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      formatted: PropTypes.func,
      align: PropTypes.string,
      filter: PropTypes.shape({
        type: PropTypes.string.isRequired,
        defaultValue: PropTypes.string,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
          })
        ),
        autocomplete: PropTypes.shape({
          label: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
          unique: PropTypes.string.isRequired,
        }),
      }),
    })
  ).isRequired,
  maxWidth: PropTypes.string,
  maxHeight: PropTypes.string,
  disabled: PropTypes.bool,
  amaggi: PropTypes.bool,
  userSelectFilterCountMaisQueUm: PropTypes.bool,
  filterByUser: PropTypes.bool,
  aguarda: PropTypes.bool,

  onCallbackNaoEncotrado: PropTypes.func,
  onCallbackConfirmado: PropTypes.func,
  onCallbackClose: PropTypes.func,
  onCallbackCampoLimpo: PropTypes.func,

  onRow: PropTypes.func,

  desabilitaPesquisaInput: PropTypes.bool,
  desabilitaClearInputAtive: PropTypes.bool,
  mostraButtonLimpar: PropTypes.bool,

  disabledDigitacao: PropTypes.bool,
};

PesquisaTabelaInput.defaultProps = {
  nowrap: false,
  query: {
    wherefield: [],
    valuewherefield: [],
    typewherefield: [],
  },
  // query: {
  //   defaultKey: {
  //     wherefield: [],
  //     valuewherefield: [],
  //     typewherefield: [],
  //   },
  // },
  getValue: () => undefined,
  maxWidth: 'md',
  maxHeight: '',
  disabled: false,
  amaggi: false,
  userSelectFilterCountMaisQueUm: false,
  filterByUser: true,
  aguarda: false,

  onCallbackNaoEncotrado: () => {},
  onCallbackConfirmado: () => {},
  onCallbackClose: () => {},
  onCallbackCampoLimpo: () => {},

  onRow: () => undefined,

  desabilitaPesquisaInput: false,
  desabilitaClearInputAtive: false,
  mostraButtonLimpar: false,
  disabledDigitacao: false,
};
